export const WS_RESPONSE_TYPE=  {
  RECONNECT: 'reconnect', // Invalid data passed to socket io. For example: userId: 0
  ACCEPTED: 'accepted', // Event accepted
  AUTH_FAILED: 'auth-failed', // When the user hash is not valid.
  NOTIFY: 'notify',
  NOTIFY_ACCEPTED: 'notificationAccepted',
  NOTIFY_USER_MISMATCH: 'depositNotificationUserMismatch',
} as const
